import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.798 14.989C4.652 14.989 1.146 10.869 1 4h3.079c.1 5.033 2.37 7.143 4.168 7.604V4.011h2.9v4.34c1.774-.186 3.64-2.164 4.269-4.34h2.899a8.3 8.3 0 0 1-1.38 3.15 8.5 8.5 0 0 1-2.553 2.345 8.8 8.8 0 0 1 2.911 2.263A8.6 8.6 0 0 1 19 15h-3.202a5.4 5.4 0 0 0-1.72-2.649 5.6 5.6 0 0 0-2.932-1.274V15z"
    }, null, -1)
  ])))
}
export default { render: render }